export { parseTime } from '@/utils'

export const articleStatusFilter = (status: string) => {
  const statusMap: { [key: string]: string } = {
    published: 'success',
    draft: 'info',
    deleted: 'danger'
  }
  return statusMap[status]
}

export const uppercaseFirstChar = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

// 字典转换
export const filterDicts = (value:string | number, dicts:Array<object>, type:any = { code: 'code', name: 'name' }) => {
  const hasMap:any = dicts.filter((el:any) => { return String(el[type.code]) === String(value) })
  if (hasMap.length > 0) {
    return hasMap[0][type.name]
  } else {
    return '-'
  }
}

// 字典转换
export const filterDictsForObj = (value:string | number, dicts:any) => {
  if (!dicts) return '-'
  return dicts[value] || '-'
}
/**
 * 单位转换
 */
export function toThousandFilter (num:number) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

// 获取月份并对获取为0时做12月份的转换
export function getMonthFilter (num:number) {
  const month = new Date().getMonth() + num
  const Y = month > 0 ? new Date().getFullYear() : new Date().getFullYear() - 1
  const M = month > 0 ? month : 13 + num
  return `${Y}年${M}月`
}
